import { store } from "../store/index";
import {
  getEval,
  generateEvaluation,
  getSimpleEvaluation,
  putEvaluation,
  evaluationConfirm,
  getDataToEvaluation,
  consultEval,
  filterEvaluations,
  listEvaluationsToExport,
  getMyEval,
  putConfirmAutoEvaluation,
  putFinalEvaluation,
  putNotifiedEvaluation,
  createCalibration,
  putAutoObjectUnitEvaluation,
  putManagerObjectUnitEvaluation,
  putConfirmManagerºEvaluation,
  exportEmails,
} from "../store/actions/EvaluationActions";

export const getUserEvaluation = async (uuid) => {
  const result = await store.dispatch(getSimpleEvaluation([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const getEvaluation = async (year) => {
  const result = await store.dispatch(getEval(year));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const createEvaluation = async (values, year, userUuid) => {
  const obj = { ...values };
  obj.evaluatedUuid = userUuid;
  obj.year = Number(year);
  const result = await store.dispatch(generateEvaluation(obj));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const updateEvaluation = async (values, evaluation) => {
  const obj = { ...values };
  const param = [evaluation.uuid];
  const result = await store.dispatch(putEvaluation(obj, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const confirmEvaluation = async (uuid) => {
  const result = await store.dispatch(evaluationConfirm([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const dataForEval = async (userUuid) => {
  const result = await store.dispatch(getDataToEvaluation([userUuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const consultEvaluations = async (filter) => {
  const result = await store.dispatch(consultEval(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

/**
 * List evaluations
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterEvaluations(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List export
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listEvaluationsToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const getMyEvaluation = async () => {
  const result = await store.dispatch(getMyEval());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const confirmAutoEvaluation = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(putConfirmAutoEvaluation({}, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const setEvaluation = async (values, skills, uuid) => {
  const obj = { ...values };
  obj.professionalSkill = skills;
  const param = [uuid];
  const result = await store.dispatch(putFinalEvaluation(obj, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const notifiedEvaluation = async (values, uuid) => {
  const obj = { ...values };
  const param = [uuid];
  const result = await store.dispatch(putNotifiedEvaluation(obj, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const calibration = async (file, yearSelected) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", Number(yearSelected.value));
  const result = await store.dispatch(createCalibration(formData));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const setAutoUnitObj = async (values, data) => {
  const obj = { ...values };
  const param = [data.uuid];
  const result = await store.dispatch(putAutoObjectUnitEvaluation(obj, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const setManagerUnitObj = async (values, data) => {
  const obj = { ...values };
  const param = [data.uuid];
  const result = await store.dispatch(
    putManagerObjectUnitEvaluation(obj, param)
  );
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const confirmManagerEvaluation = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(putConfirmManagerºEvaluation({}, param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const listToExportEmails = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(exportEmails(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};
